import { Title } from "@mantine/core";
import useProductCategoryManager from "../../hooks/useProductCategoryManager";
import { RoutePaths } from "../../router";

function MainPageCategoryPill({ name, id }: { name: string; id: number }) {
  return (
    <a
      href={RoutePaths.Product + `?category=${id}`}
      className="inline-block px-4 py-2 bg-white mr-2 mb-2 shadow-sm rounded-full border-neutral-200 border hover:bg-neutral-50 md:text-xs"
    >
      {name}
    </a>
  );
}

export default function MainPageCategoryView() {
  const { data: productCategories } =
    useProductCategoryManager().getProductCategory();

  function flat() {
    if (productCategories === undefined) return undefined;
    let data: any[] = [];
    let stack = [...productCategories];

    // flatten all sub-categories as 1D array
    while (stack.length !== 0) {
      const cur: any = stack.pop();
      const { id, name, index, children } = cur;
      data = [...data, { id, name, index }];

      // if (children !== undefined) {
      //   stack.push(...children);
      // }
    }

    return data.sort((a, b) => a.index - b.index);
  }
  const flattenedCategoryData =
    (productCategories !== undefined && flat()) || undefined;

  return (
    <div className="main-page-category-view flex flex-col gap-4">
      <div className="px-4 pt-4">
        <Title order={3}>Danh mục sản phẩm</Title>
      </div>

      {/*  */}
      <div className="inline-block px-4">
        {flattenedCategoryData &&
          flattenedCategoryData.map((data) => {
            return (
              <MainPageCategoryPill
                name={data.name}
                id={data.id}
                key={data.id}
              />
            );
          })}
      </div>
    </div>
  );
}
